import React, { Component } from 'react';
// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';
import { Link, Redirect } from 'react-router-dom';

import ResetPasswordContainer from 'containers/AccountActivation/ResetPasswordContainer';
import ActivationCodeContainer from 'containers/AccountActivation/ActivationCodeContainer';
import AccountActivationForm from 'containers/AccountActivation/AccountActivationForm';

class AccountActivationContainer extends Component {
    componentDidMount() {
        const code = this.props.match.params.code;
        code ? this.props.signInWithCustomToken(code) : null;
    }

    getProviderActivationCase = () => {
        const { isActivationFlowFinished, signinTokenIsValid } = this.props;

        let activationCase = 'unknownCase';

        signinTokenIsValid
            ? (activationCase = 'passwordReset')
            : isActivationFlowFinished
            ? (activationCase = 'activationSuccesful')
            : (activationCase = 'invalidToken');

        return activationCase;
    };

    getClientActivationCase = () => {
        const {
            isActivationFlowFinished,
            signinTokenIsValid,
            isValidActivationCode,
            activationFormSubmitted,
        } = this.props;

        let activationCase = 'unknownCase';

        isActivationFlowFinished
            ? (activationCase = 'activationSuccesful')
            : activationFormSubmitted
            ? (activationCase = 'passwordReset')
            : isValidActivationCode
            ? (activationCase = 'activationForm')
            : signinTokenIsValid
            ? (activationCase = 'activationCodeValidation')
            : (activationCase = 'invalidToken');

        return activationCase;
    };

    getActivationStep = activationCase => {
        let activationCaseBody = null;

        switch (activationCase) {
            case 'passwordReset':
                activationCaseBody = <ResetPasswordContainer />;
                break;
            case 'activationCodeValidation':
                activationCaseBody = <ActivationCodeContainer />;
                break;
            case 'activationForm':
                activationCaseBody = <AccountActivationForm />;
                break;
            case 'activationSuccesful':
                const { userData, userId } = this.props;
                let redirectionLocation;
                console.log(
                    'Activation Successful. Redirecting. Getting client data',
                );
                userData.roles &&
                (userData.roles.accountAdmin || userData.roles.staffAdmin)
                    ? (redirectionLocation = '/company/dashboard')
                    : (redirectionLocation = '/');
                activationCaseBody = <Redirect to={redirectionLocation} />;
                break;
            default:
                activationCaseBody = <div />;
                break;
        }
        return activationCaseBody;
    };

    render() {
        const { userData, isActivationFlowFinished } = this.props;
        const {
            getProviderActivationCase,
            getClientActivationCase,
            getActivationStep,
        } = this;
        let activationCase = null;
        let activationStep = null;

        if (userData) {
            if (!userData.isPendingActivation) {
                // IF ALREADY ACTIVATED SKIP THE ACTIVATION FLOW
                const redirectLocation =
                    userData && !userData.provider ? `/` : `/company/dashboard`;
                return <Redirect to={`${redirectLocation}`} />;
            } else {
                // IF NOT ACTIVATED GO THROUGH APPLICATION FLOW
                activationCase = userData.provider
                    ? getProviderActivationCase()
                    : getClientActivationCase();

                activationStep = getActivationStep(activationCase);
                return <div> {activationStep} </div>;
            }
        }
        return <div />;
    }
}

const mapStateToProps = ({ auth, client }) => ({
    signinTokenIsValid: auth.signinTokenIsValid,
    isActivationFlowFinished: auth.isActivationFlowFinished,
    isValidActivationCode: auth.isValidActivationCode,
    activationFormSubmitted: auth.activationFormSubmitted,
    userData: client.clientData,
    userId: auth.authData.uid,
});

export default connect(
    mapStateToProps,
    actions,
)(AccountActivationContainer);



// WEBPACK FOOTER //
// ./src/js/containers/AccountActivation/index.jsx